import React from 'react';

function PhoneField({ id, label, isRequired, updateFieldData, className }) {
  const onLabelChange = (e) => {
    updateFieldData(id, { label: e.target.value });
  };
  
  const onIsRequiredChange = (e) => {
    updateFieldData(id, { isRequired: e.target.checked });
  };

  return (
    <div className={className}>
      <div className="flex flex-col space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Label</label>
          <input
            type="text"
            value={label}
            onChange={onLabelChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        <div className="flex items-center">
          <input
            id={`required-${id}`}
            type="checkbox"
            checked={isRequired}
            onChange={onIsRequiredChange}
            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
          />
          <label htmlFor={`required-${id}`} className="ml-2 block text-sm text-gray-700">
            Required field
          </label>
        </div>

        <div className="mt-2">
          <div className="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span className="text-sm text-gray-500">This is a phone number field with international format (name="phone")</span>
          </div>
        </div>

     
      </div>
    </div>
  );
}

export default PhoneField;